<template>
  <div
    class="cancel-drag"
    :style="{ width: widthOnTimelineView }"
  >
    <span class="esc-key">Esc</span>
    <span class="cancel-message">{{ translate('toCancelDrag') }}</span>
  </div>
</template>

<script>
export default {
  name: 'CancelDragLabel',

  computed: {
    pressedEscCancelDragging() {
      return this.$store.getters.getPressedEscCancelDragging;
    },

    timelineSidebarWidth() {
      return this.$store.getters.getTimelineSidebarWidth;
    },

    widthOnTimelineView() {
      return this.isCardsLayoutTimeline ? `${this.timelineSidebarWidth}px` : '';
    },

    isCardsLayoutTimeline() {
      return this.$store.getters.cardsLayout() === 'timeline';
    },
  },

  watch: {
    pressedEscCancelDragging(newVal) {
      if (newVal) {
        var mouseUpEvent = new MouseEvent('mouseup', {
          bubbles: true,
          cancelable: true,
          view: window,
        });
        document
          .querySelector('.dragging-card, .timeline-dragging-card')
          .dispatchEvent(mouseUpEvent);
        this.$store.dispatch('setPressedEscCancelDrag', false);
      }
    },
  },
};
</script>

<style lang="scss">
.cancel-drag {
  @apply hidden items-center justify-center text-deEmphasised-text mt-1;
  font-size: 12px;
  line-height: 18px;

  .esc-key {
    @apply border border-solid border-standard-border rounded px-1 bg-standard-bg mr-1;
  }
}
</style>
